/* dfcourse 2026-10-23 - withdrawal-waiver consent for course products.
   PDP: add to cart (form button and sticky bar) does nothing until the consent box is ticked.
   Cart page / drawer: a course line without the property blocks checkout; a checkbox writes it. */
(function () {
  'use strict';
  var KEY = 'Immediate access consent';
  var COURSE_ID = 10677609693450; /* product type is translated per locale, so key on id / SKU only */
  function isCourse(it) { return it.product_id === COURSE_ID || /^DF-COURSE/i.test(it.sku || ''); }

  function dfCourseBlocked(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!isCourse(it)) continue;
      var v = it.properties && it.properties[KEY];
      if (!v || !String(v).trim()) return true;
    }
    return false;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { dfCourseBlocked: dfCourseBlocked, KEY: KEY };
  if (typeof document === 'undefined') return;
  window.dfCourseBlocked = dfCourseBlocked;

  function pdpBox() { return document.querySelector('[data-df-consent-input]'); }

  function showError(box) {
    var wrap = box.closest('[data-df-course-consent]');
    var err = wrap && wrap.querySelector('[data-df-consent-error]');
    if (err) err.hidden = false;
    if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
  }

  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;

    var atc = t.closest('[data-atc-form], [data-action-atc]');
    var box = pdpBox();
    var atcForm = atc && (atc.form || atc.closest('form'));
    var atcFormId = atc && (atc.getAttribute('form') || (atcForm && atcForm.getAttribute('id')));
    if (atc && box && (atc.hasAttribute('data-action-atc') || (atcFormId === box.getAttribute('form')))) {
      if (!box.checked) { stop(e); showError(box); return; }
      if (atc.hasAttribute('data-action-atc')) {
        /* the sticky bar posts without properties: hand over to the real form button, which carries them */
        var main = document.querySelector('[data-atc-form]');
        if (main) { stop(e); main.click(); }
      }
      return;
    }

    var co = t.closest('[name="checkout"], .t4s-btn__checkout, #df-sticky-checkout-btn');
    if (co && document.querySelector('[data-df-course-block="true"]')) {
      stop(e);
      var n = document.querySelector('[data-df-course-cart]');
      if (n && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var box = pdpBox();
    if (box && f && f.getAttribute && f.getAttribute('id') && box.getAttribute('form') === f.getAttribute('id') && !box.checked) { stop(e); showError(box); return; }
    var sub = e.submitter;
    if (sub && sub.name === 'checkout' && document.querySelector('[data-df-course-block="true"]')) stop(e);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-df-consent-input]')) {
      var err = t.closest('[data-df-course-consent]').querySelector('[data-df-consent-error]');
      if (err) err.hidden = true;
      return;
    }
    if (!t.matches('[data-df-cart-consent]') || !t.checked) return;
    var wrap = t.closest('[data-df-course-cart]');
    var errEl = wrap && wrap.querySelector('[data-df-cart-error]');
    if (errEl) errEl.hidden = true;
    t.disabled = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var label = (wrap.querySelector('.df-course-cart__label span') || {}).textContent || 'Yes';
        var jobs = cart.items.filter(function (it) {
          return isCourse(it) && !(it.properties && it.properties[KEY]);
        });
        return jobs.reduce(function (p, it) {
          return p.then(function () {
            var props = {};
            Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
            props[KEY] = label;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); });
          });
        }, Promise.resolve());
      })
      .then(function () {
        if (t.closest('#t4s-mini_cart')) document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
        else window.location.reload();
      })
      .catch(function () {
        t.checked = false; t.disabled = false;
        if (errEl) errEl.hidden = false;
      });
  }, true);
})();
